import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onBeforeMount, Raw, ref } from 'vue'

import { HeaderView } from '@/models/header'

import AppMenu from '@/app/components/header/AppMenu.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AppMobile',
  setup(__props) {

const view = ref<Raw<HeaderView>>(new HeaderView())

onBeforeMount(async () => {
  await view.value.init()
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["navbar-mobile", { 'navbar-mobile--ios': view.value?.isIOS }])
  }, [
    _createVNode(AppMenu, { view: view.value }, null, 8, ["view"])
  ], 2))
}
}

})